import type { ComponentType, ReactNode } from 'react';

export type DocumentFormProvider = ComponentType<{ children: ReactNode }>;
export type DocumentFormComponentLoader = () => Promise<{ default: ComponentType<any> }>;

export interface DocumentFormRegistryEntry {
  endpoint: string;
  FormComponent?: ComponentType<any>;
  loadFormComponent?: DocumentFormComponentLoader;
  Provider?: DocumentFormProvider;
  controller?: 'default' | 'external';
}

export interface DocumentFormRegistryDefinition {
  keys: string | string[];
  entry: DocumentFormRegistryEntry;
}

export type DocumentFormRegistry = Record<string, DocumentFormRegistryEntry>;

export const buildDocumentFormRegistry = (definitions: DocumentFormRegistryDefinition[]): DocumentFormRegistry => {
  const registry: DocumentFormRegistry = {};

  for (const definition of definitions) {
    const keys = Array.isArray(definition.keys) ? definition.keys : [definition.keys];

    for (const key of keys) {
      if (!key) continue;
      registry[key] = definition.entry;
    }
  }

  return registry;
};

export const resolveDocumentFormRegistryEntry = (
  documentType: string,
  registry: DocumentFormRegistry
): DocumentFormRegistryEntry | null => {
  if (!documentType) return null;
  return registry[documentType] ?? null;
};
